import React from "react";

const CalenderIcon = ({
  width = 10,
  height = 10,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    className={className}
  >
    <path
      d="M1 3.5H9M1 3.5V7.9001C1 8.46015 1 8.74003 1.10899 8.95394C1.20487 9.1421 1.35774 9.29524 1.5459 9.39111C1.7596 9.5 2.0395 9.5 2.59846 9.5H7.40155C7.9605 9.5 8.23999 9.5 8.4537 9.39111C8.64186 9.29524 8.79524 9.1421 8.89111 8.95394C9 8.74024 9 8.46075 9 7.90179V3.5M1 3.5V3.1001C1 2.54005 1 2.25981 1.10899 2.0459C1.20487 1.85774 1.35774 1.70487 1.5459 1.60899C1.75981 1.5 2.04005 1.5 2.6001 1.5H3M9 3.5V3.09845C9 2.5395 9 2.2596 8.89111 2.0459C8.79524 1.85774 8.64186 1.70487 8.4537 1.60899C8.23979 1.5 7.96015 1.5 7.4001 1.5H7M7 0.5V1.5M7 1.5H3M3 0.5V1.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default CalenderIcon;
